import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IConfigureMetaLeadsRequest } from '../../extViewmodels/sdk/models/Ads';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useConfigureMetaLeads = ({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IConfigureMetaLeadsRequest) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: userSession.impersonationContext,
					urlPath: 'ads/providers/meta/configure',
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
